/**
 * Release 4 switch for "Re-read my sources" and Show changes in Revisit Brand Setup (lane W7 flipped it
 * when re-reading shipped). While false, a revisit offers "Edit manually" only and no Release 3 sentence
 * promises a re-read or highlighted changes (spec:66). One file per Release 4 lane, so each lane flips
 * only its own. Like every Brand Workspace v2 page, it shows only while the install's flag is on.
 */
export const REREAD_ENABLED: boolean = true;
